import { Card, Col } from 'react-bootstrap';
import TextLoading from '@/app/common/components/skeleton/TextLoading';

const Block = ({
  width,
  height,
  className = ''
}: {
  width: number | string;
  height: number;
  className?: string;
}) => (
  <span className={`d-block ${className}`.trim()}>
    <TextLoading
      width={width}
      height={height}
      isWidthPx={typeof width === 'number'}
    />
  </span>
);

export const CompetitorsChartPreload = () => (
  <Card className="h-100 overflow-hidden" aria-busy="true">
    <Card.Header className="py-2 bg-body">
      <Block width="42%" height={14} className="mb-2" />
      <Block width="65%" height={10} />
    </Card.Header>
    <Card.Body className="py-3 d-flex flex-column justify-content-between">
      <div className="d-flex align-items-end gap-2" style={{ height: 220 }}>
        {[38, 64, 48, 82, 56, 72, 44, 90, 60, 76].map(
          (height, index) => (
            <Block
              key={index}
              width="100%"
              height={height}
              className="flex-grow-1"
            />
          )
        )}
      </div>
      <div className="d-flex justify-content-between mt-3">
        <Block width="18%" height={10} />
        <Block width="18%" height={10} />
        <Block width="18%" height={10} />
      </div>
    </Card.Body>
  </Card>
);

export const CompetitorDomainMetricsPreload = () => (
  <>
    {Array.from({ length: 3 }, (_, index) => (
      <Col xs={12} md={4} key={index}>
        <Card className="h-100 mb-0" aria-busy="true">
          <Card.Body className="d-flex align-items-center gap-3 py-3 px-3">
            <Block width={44} height={44} />
            <div className="flex-grow-1">
              <Block width="55%" height={11} className="mb-3" />
              <Block width="35%" height={22} />
            </div>
          </Card.Body>
        </Card>
      </Col>
    ))}
    <Col xs={12}>
      <Card aria-busy="true">
        <Card.Header className="py-2 bg-body">
          <Block width="38%" height={14} />
        </Card.Header>
        <Card.Body>
          <Block width="100%" height={210} />
        </Card.Body>
      </Card>
    </Col>
  </>
);
